/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ writes: NonNullable<unknown> }} Canvas_Data_Write_Grant_BodyInputs */



/**
* | output |
* | --- |
* | "Allow it to change data in the dataset through its bound writes: {writes}?" |
*
* @param {Canvas_Data_Write_Grant_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_data_write_grant_body = /** @type {((inputs: Canvas_Data_Write_Grant_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Data_Write_Grant_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Darf sie über ihre gebundenen Schreibvorgänge Daten im Datensatz ändern: ${i?.writes}?`)
	return /** @type {LocalizedString} */ (`Allow it to change data in the dataset through its bound writes: ${i?.writes}?`)
});